import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import QuoteForm from './QuoteForm';

const bullets = [
  { key: 'bullet_1', icon: 'ri-time-line' },
  { key: 'bullet_2', icon: 'ri-search-line' },
  { key: 'bullet_3', icon: 'ri-mail-send-line' },
  { key: 'bullet_4', icon: 'ri-shield-check-line' },
  { key: 'bullet_5', icon: 'ri-file-shield-line' },
];

export default function Hero() {
  const { t } = useTranslation('soumission');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section id="hero" className="relative bg-gradient-to-br from-[#E8ECF5] via-white to-soft-gray pt-28 pb-16 md:pt-32 md:pb-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        {/* Breadcrumb */}
        <nav className="mb-8" aria-label="Fil d'Ariane">
          <ol className="flex items-center gap-2 text-sm text-slate-primary/50">
            <li>
              <button
                onClick={() => {
                  if (window.REACT_APP_NAVIGATE) window.REACT_APP_NAVIGATE('/');
                }}
                className="hover:text-copper transition-colors"
              >
                {t('breadcrumb_home')}
              </button>
            </li>
            <li><i className="ri-arrow-right-s-line" /></li>
            <li className="text-slate-primary font-medium">{t('breadcrumb_current')}</li>
          </ol>
        </nav>

        <div
          ref={ref}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* LEFT - Texte */}
          <div className="pt-2">
            <h1 className="font-manrope font-extrabold text-slate-primary text-3xl sm:text-4xl md:text-5xl lg:text-[56px] leading-tight mb-5">
              {t('hero_h1')}
            </h1>
            <p className="text-slate-primary/60 text-base md:text-lg lg:text-xl mb-8 leading-relaxed">
              {t('hero_subtitle')}
            </p>

            <ul className="space-y-3">
              {bullets.map((b, idx) => (
                <li key={idx} className="flex items-center gap-3 text-slate-primary text-sm md:text-base">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-copper/10 shrink-0">
                    <i className={`${b.icon} text-copper text-sm`} />
                  </span>
                  {t(b.key)}
                </li>
              ))}
            </ul>
          </div>

          {/* RIGHT - Formulaire */}
          <div className="lg:sticky lg:top-28">
            <QuoteForm />
          </div>
        </div>
      </div>
    </section>
  );
}